import { Lock } from "lucide-react";

/** Marks a confidential PPP. The backend already masks the name/description — this is the affordance only. */
export const PppLock = () => (
  <span title="Confidential" className="flex shrink-0 items-center text-muted-foreground">
    <Lock className="h-3 w-3" />
  </span>
);
